import { ArrowLeft } from 'lucide-react';
import { useState, useEffect } from 'react';
import { OTPInput } from './OTPInput';
import { FormButton } from './FormButton';

interface EnterCodeScreenProps {
  onBack: () => void;
  onContinue: () => void;
  method: 'phone' | 'email';
  contact: string;
}

export const EnterCodeScreen = ({
  onBack,
  onContinue,
  contact,
}: EnterCodeScreenProps) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [canResend, setCanResend] = useState(false);
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [countdown]);

  const handleContinue = () => {
    setLoading(true);
    // Simulate API verification
    setTimeout(() => {
      setLoading(false);
      onContinue();
    }, 1500);
  };

  const handleResend = () => {
    if (!canResend) return;
    setCanResend(false);
    setCountdown(30);
    // Simulate resending
  };

  const isComplete = code.length === 6;

  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      {/* Header */}
      <div className="bg-white border-b border-[#E5E7EB] sticky top-0 z-10">
        <div className="flex items-center gap-3 p-4">
          <button
            onClick={onBack}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-[#F7F8FA] transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-[#111827]" />
          </button>
          <h1 className="text-lg font-bold text-[#111827]">Ingresa el código</h1>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-6 pt-8">
        <div className="text-center space-y-2">
          <p className="text-sm text-[#6B7280]">
            Te enviamos un código de 6 dígitos
          </p>
          <p className="text-sm font-medium text-[#111827]">
            {contact}
          </p>
        </div>

        <div className="py-4">
          <OTPInput value={code} onChange={setCode} />
        </div>

        <div className="text-center">
          <button
            onClick={handleResend}
            disabled={!canResend}
            className={`text-sm font-medium transition-colors ${
              canResend
                ? 'text-[#FF6A2A] hover:text-[#C2410C]'
                : 'text-[#6B7280] cursor-not-allowed'
            }`}
          >
            {canResend ? 'Reenviar código' : `Reenviar en ${countdown}s`}
          </button>
        </div>

        <div className="pt-4">
          <FormButton
            onClick={handleContinue}
            loading={loading}
            disabled={!isComplete}
          >
            Continuar
          </FormButton>
        </div>
      </div>
    </div>
  );
};
